import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import PropTypes from "prop-types";
import React from "react";
import { Button } from "@icg360/ui-toolkit";
export var Action = function Action(_ref) {
  var label = _ref.label,
      handleClick = _ref.handleClick,
      id = _ref.id,
      isReadOnly = _ref.isReadOnly,
      quoteId = _ref.passthroughProps.quoteId;
  var opts = {};
  if (isReadOnly) opts.disabled = true;

  var onClick = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return handleClick({
                label: label,
                quoteId: quoteId
              });

            case 3:
              _context.next = 8;
              break;

            case 5:
              _context.prev = 5;
              _context.t0 = _context["catch"](0);
              // eslint-disable-next-line no-console
              console.error(_context.t0);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 5]]);
    }));

    return function onClick() {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/React.createElement(Button, _extends({}, opts, {
    id: id,
    onClick: onClick,
    "data-bdd": "QTC " + id + " Button"
  }), label);
};
Action.propTypes = {
  handleClick: PropTypes.func.isRequired,
  id: PropTypes.string,
  isReadOnly: PropTypes.bool,
  passthroughProps: PropTypes.shape({
    quoteId: PropTypes.string
  }),
  label: PropTypes.string,
  status: PropTypes.shape({
    loading: PropTypes.bool
  })
};
Action.defaultProps = {
  status: {
    loading: false
  }
};